import { useParams } from "react-router-dom";
import WebLayout from "./component/WebLayout";

function WebPage({ datas }) {
  const { slug } = useParams();
  return (
    <div>
      {datas
        .filter((item) => item.slug === slug)
        .map((item) => (
          <WebLayout key={item.id} data={item} />
        ))}
    </div>
  );
}

export default WebPage;
